import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vitrine-menu-coriolis',
    templateUrl: './vitrine-menu-coriolis.component.html',
    styleUrls: ['./vitrine-menu-coriolis.component.css'],
    standalone: false
})
export class VitrineMenuCoriolisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
